import { useTranslation } from "@bounce/i18n"

import type { Interpolations } from "./useInterpolations"
import type { CityData } from "@/libs/bounce/cities"
import { interpolateText } from "@/libs/prismic/helpers"

export type UseSEOOptions = {
  city: Pick<CityData, "metaTitle" | "metaDescription" | "slug">
  interpolations: Interpolations
  isPrismicMetaEnabled?: boolean
}

const useMetaTitle = ({ city, interpolations, isPrismicMetaEnabled }: UseSEOOptions) => {
  const { t } = useTranslation("marketing-ls-city")

  if (isPrismicMetaEnabled && city.metaTitle) {
    return interpolateText(city.metaTitle, interpolations)
  }

  return t("page.city.metaTitleV21", "Luggage Storage in {CITY_NAME} - Safe & Flexible From {LOWEST_PRICE}/day", {
    CITY_NAME: interpolations.CITY_NAME,
    LOWEST_PRICE: interpolations.LOWEST_PRICE,
  })
}

const useMetaDescription = ({ city, interpolations, isPrismicMetaEnabled = false }: UseSEOOptions) => {
  const { t } = useTranslation("marketing-ls-city")

  if (isPrismicMetaEnabled && city.metaDescription) {
    return interpolateText(city.metaDescription, interpolations)
  }

  return t(
    "screen.cityScreen.metaDescriptionV21",
    "Store your bags easily in {CITY_NAME} with Bounce. Safe and flexible luggage storage at trusted locations near you. Book online from just {LOWEST_PRICE}/day",
    {
      CITY_NAME: interpolations.CITY_NAME,
      LOWEST_PRICE: interpolations.LOWEST_PRICE,
    },
  )
}

export const useSEO = ({ city, interpolations, isPrismicMetaEnabled = false }: UseSEOOptions) => {
  const metaTitle = useMetaTitle({ city, interpolations, isPrismicMetaEnabled })
  const metaDescription = useMetaDescription({ city, interpolations, isPrismicMetaEnabled })

  return {
    metaTitle,
    metaDescription,
  }
}
